import createCrudService from '@core/api/create-crud-service';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

import type { TBaseQuery } from '@shared/types/base-query';
import type { TLeadReferal } from '@shared/types/lead-referal';

export type TReferalsListQuery = TBaseQuery;

const leadReferalApi = createCrudService<TLeadReferal, TReferalsListQuery>({
  queryKey: [QUERY_KEYS.getReferList],
  url: 'lead-referals',
});

export default leadReferalApi;
